import { useState } from "react";
import styled from "styled-components";
import { Column } from "../../../../components/Column";
import { Row } from "../../../../components/Row";
import { Input } from "../../../../components/Input";
import { Button, ChevronIcon, Content, Divider, Field, Label, Toggle } from "../../../../components/Forms";
import { categorias, getGeneralResults, Search } from "../../../../hooks/useGeneralSearch";
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import { Accordion } from "../../../../components/Accordion";
import { Select } from "../../../../components/Select";
import {indices} from "../../../../mocks/indices"
import { TreeSelect } from "../../../../components/TreeSelect";

interface paramsProps {
  setResult(value: any): void;
  initialSearch?: Search;
}

export function Form({ setResult, initialSearch = {} }: paramsProps) {
  
  const [initialType, setInitialType] = useState(initialSearch?.initialDate? 'date' : 'text');
  const [finalType, setFinalType] = useState(initialSearch?.finalDate? 'date' : 'text');

  const [buscaLivre, setLivre] = useState(initialSearch?.search_text? initialSearch?.search_text : '');
  const [initialDate, setInitialDate] = useState(initialSearch?.initialDate? initialSearch?.initialDate : '');
  const [finalDate, setFinalDate] = useState(initialSearch?.finalDate? initialSearch?.finalDate : '');
  const [categoria, setCategoria] = useState(initialSearch?.categoria? initialSearch?.categoria : '');
  const [indice, setIndice] = useState(initialSearch?.indice? initialSearch?.indice : '');
  const [isFormOpen, setIsFormOpen] = useState(false);

  async function useSubmit(e: any) {
    e.preventDefault();
    const data = await search();
    setResult([...data?.decisions?.results, ...data?.normas?.results, ...data?.dissertations?.results, ...data?.publications?.results]);
  }

  const selectCategorias = Object.entries(categorias).map(([key, value]) => (value))

  async function search() {
    const result = await getGeneralResults({
      search_text: buscaLivre,
      initialDate,
      finalDate,
      categoria,
      indice
    });
    return result;
  }

  return (
    <>
      <Toggle onClick={() => setIsFormOpen(!isFormOpen)} customWidth="calc(100% - 54px)" margin="auto">
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </Toggle>
      <Accordion isOpen={isFormOpen} hasBorder={false} margin="0" customWidth="calc(46% - 12px)">
        <Content
          onSubmit={useSubmit}
        >
          <Row>
            <Column>
              <Label>Busca Livre</Label>
              <Input
                type="text"
                placeholder="Pesquisar"
                marginBottom="16px"
                value={buscaLivre}
                onChange={(value) => setLivre(value)}
              />
            </Column>
            <Column>
            <Label>Categoria</Label>
            <Field marginBottom="16px">
              <Select
                  value={categoria}
                  onChange={(value: any) => setCategoria(value)}
              >
                <option>Selecionar</option>
                {selectCategorias.map((index: any) => (
                  <option value={index}>{index}</option> 
                ))}
              </Select>
              <ChevronIcon size={24} />
            </Field>
            
            </Column>
          </Row>

          <Label>Índice</Label>
          <Field marginBottom="16px">
              <TreeSelect 
                data={indices} 
                marginBottom="0px"
                dropdownMaxHeight="350px"
                value={indice}
                onChange={(value: any) => setIndice(value)}
              />
              <ChevronIcon size={24} />
          </Field>
          
          <Label>Busca por Data</Label>
          <Row>
            <Field marginBottom="6px">
              <Input
                type={initialType}
                placeholder=""
                onFocus={() => setInitialType('date')}
                value={initialDate}
                onChange={(value) => setInitialDate(value)}
              />
            </Field>
            <LocalDivider>A</LocalDivider>
            <Field marginBottom="6px">
              <Input
                type={finalType}
                placeholder=""
                onFocus={() => setFinalType('date')}
                value={finalDate}
                onChange={(value) => setFinalDate(value)}
              />
            </Field>
          </Row>
              
          <Button>Pesquisar</Button>
        </Content>
      </Accordion>
    </>
  );
}


const LocalDivider = styled(Divider)`
  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    display: none;
  }
`;